import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
// import { MatPaginator, MatSort } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ReportHistoryTableDataSource } from './report-history-table-datasource';
import { AuthService } from '../../services/auth.service';
import {
  ReportHistory,
  ReportService,
  Report,
} from '../../services/report.service';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'auth-suite-softsplice-co-za-report-history-table',
  templateUrl: './report-history-table.component.html',
  styleUrls: ['./report-history-table.component.scss'],
  standalone: false,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ReportHistoryTableComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: ReportHistoryTableDataSource;
  // filterReportId = 0;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. 'description','reportPermission', ,'reportFormat' */
  displayedColumns = [
    'id',
    'jobOnServer',
    'Error',
    'groupName',
    'requestedDate',
    'requestedTime',
    'completionDate',
    'completionTime',
    'username',
    'Download',
  ];

  headerMap = new Map()
    .set('id', 'ID')
    // .set('reportName', 'Report Name')
    //.set('description', 'Description')
    // .set('shortId', 'Short ID')
    .set('jobOnServer', 'Job On Server')
    .set('Error', 'Error')
    .set('groupName', 'Group')
    //.set('reportPermission', 'Permission')
    .set('requestedDate', 'Requested Date')
    .set('requestedTime', 'Requested Time')
    .set('completionDate', 'Completion Date')
    .set('completionTime', 'Completion Time')
    .set('username', 'User');
  // .set('reportFormat', 'Format');
  expandedElement: ReportHistory | null;

  selectedReportHistory: ReportHistory;
  selectedReport: Report;
  formatImgMap = new Map()
    .set('html', '/assets/img/html.png')
    .set('chrome-pdf', '/assets/img/pdf.png')
    .set('html-to-xlsx', '/assets/img/excel-icon.png');

  fileName: string;
  private file: any;

  @Input() set report(report: Report) {
    this.selectedReport = report;
  }

  constructor(
    private reportService: ReportService,
    public authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.paginator.pageSize = 10;
    this.sort.active = 'id';
    this.sort.direction = 'desc';

    this.dataSource = new ReportHistoryTableDataSource(this.reportService);
    console.log('ReportHistory ngOnInit');
    //this.dataSource.loadReportHistory(0, 10, 'id', 'desc', 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.report.currentValue !== undefined) {
    //   this.dataSource.loadReportHistory(0, 10, 'id', 'desc', this.selectedReport.id);
    // }
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();

    merge(this.paginator.page, this.sort.sortChange)
      .pipe(
        tap(() =>
          this.dataSource.loadReportHistory(
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction,
            this.selectedReport.id
          )
        )
      )
      .subscribe();
  }

  downloadButtonClick(rowElement: ReportHistory) {
    console.log(`rowElement`);
    console.log(rowElement);
    this.selectedReportHistory = rowElement;
    const reportDate = moment(rowElement.completionDate).format('YYYY-MM-DD');
    const regEx = new RegExp(':', 'g');
    console.log(rowElement.completionTime);
    const reportTime = rowElement.completionTime.replace(regEx, '');
    // const reportTime = rowElement.completionTime;
    const reportId = this.pad(rowElement.reportId, 4);

    if (rowElement.reportFormat === 'chrome-pdf') {
      this.fileName = `${reportDate}_${reportTime}_${reportId}_${rowElement.reportName}.pdf`;
    } else if (rowElement.reportFormat === 'html-to-xlsx') {
      this.fileName = `${reportDate}_${reportTime}_${reportId}_${rowElement.reportName}.xlsx`;
    } else {
      this.fileName = `${reportDate}_${reportTime}_${reportId}_${rowElement.reportName}.html`;
    }
    console.log(`rowElement.id: ${rowElement.id}`);
    this.reportService.downloadReport(rowElement.id).subscribe((resp) => {
      //console.log(resp);
      console.log(`rowElement.reportFormat : ${rowElement.reportFormat}`);
      if (rowElement.reportFormat === 'chrome-pdf') {
        this.file = new Blob([resp], { type: 'application/pdf' });
        this.file.name = this.fileName;
      } else if (rowElement.reportFormat === 'html-to-xlsx') {
        this.file = new Blob([resp], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        this.file.name = this.fileName;
      } else {
        this.file = new Blob([resp], { type: 'text/html' });
        this.file.name = this.fileName;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const downloadURL = URL.createObjectURL(this.file);
      // window.open(downloadURL);

      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = this.fileName;
      link.click();

      // window.URL.revokeObjectURL(this.file);
    });
  }

  reloadReports() {
    console.log('reload Report History');

    this.paginator.pageSize = 10;
    this.dataSource = new ReportHistoryTableDataSource(this.reportService);
    this.dataSource.loadReportHistory(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.sort.active,
      this.sort.direction,
      this.selectedReport.id
    );
  }
  pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }
}
